import React from 'react'
import cx from 'classnames'
import styles from './index.css'

const Module = ({
  className,
  contentClassName,
  header,
  headerIcon,
  headerText,
  content,
  children,
}) => (
  <div className={cx(styles.module, className)}>
    {Boolean(header || headerIcon || headerText) && (
      <div className={styles.moduleHeader}>
        {header}
        {!header && <div className={styles.headerIcon}>{headerIcon}</div>}
        {!header && <div className={styles.headerText}>{headerText}</div>}
      </div>
    )}
    <div className={cx(styles.moduleContent, contentClassName)}>
      {content}
      {children}
    </div>
  </div>
)

export default Module



// WEBPACK FOOTER //
// ./src/components/Module/index.js